import i18n from "../i18n/config";

/**
 * Get localized field value from API data
 * Falls back to English if Thai is not available
 * 
 * @param {Object} item - API data item
 * @param {string} fieldName - Base field name (e.g., 'title', 'description')
 * @param {string} fallback - Fallback value if no field is found
 * @returns {string} Localized field value
 */
export function getLocalizedField(item, fieldName, fallback = "") {
  if (!item) return fallback;
  
  const currentLang = i18n.language === "th" ? "th" : "en";
  const thField = `${fieldName}_th`;
  const enField = `${fieldName}_en`;
  
  // If Thai is selected, try Thai first, then fallback to English
  if (currentLang === "th") {
    return item[thField] || item[enField] || item[fieldName] || fallback;
  }
  
  // If English is selected, use English, fallback to Thai if English not available
  return item[enField] || item[thField] || item[fieldName] || fallback;
}

/**
 * Get localized title from API data
 * Falls back to English if Thai is not available
 */
export function getLocalizedTitle(item, fallback = "") {
  return getLocalizedField(item, "title", fallback);
}

/**
 * Get localized description from API data
 * Falls back to English if Thai is not available
 */
export function getLocalizedDescription(item, fallback = "") {
  return getLocalizedField(item, "description", fallback);
}

/**
 * Check if a value is valid (not empty, not "-", not null, not undefined)
 */
export function isValidValue(val) {
  return val && val !== "-" && val.trim() !== "";
}

/**
 * Get current language code (th or en)
 */
export function getCurrentLanguage() {
  return i18n.language === "th" ? "th" : "en";
}

/**
 * Check if text contains Thai characters
 * @param {string} text - Text to check
 * @returns {boolean} True if text contains Thai characters
 */
export function containsThai(text) {
  if (!text || typeof text !== 'string') return false;
  // Thai Unicode range: \u0E00-\u0E7F
  const thaiRegex = /[\u0E00-\u0E7F]/;
  return thaiRegex.test(text);
}
